// extracted by mini-css-extract-plugin
export default {"errorPage":"_404page_errorPage__xf3Qb"};